import React from "react";
import classNames from "classnames";
import { useLocation } from "react-router-dom";
import { INav } from "./Nav.types";
import "./nav.sass";
import { useAppSelector } from "../../store";
import { Variants } from "../../configs/configs.types";
import {
  AUTO_REGISTER,
  COOKIES,
  FINAL,
  INFO,
  OFFERS,
  PENDING,
} from "../../constants/constantApi";
import { getFormLink } from "../../utils/getTld";
import headerDot from "../../assets/images/svg/header-nav-dot.svg";

// Single-segment routes that do NOT render the landing page; only "/" and the
// dynamic "/:seoPageHtml" slug render FirstPage with its hash sections.
const NON_LANDING_ROUTES = new Set<string>([
  PENDING,
  OFFERS,
  FINAL,
  INFO,
  COOKIES,
  AUTO_REGISTER,
]);

export function Nav({ isOpen, openMenuBurger, activeLink }: INav) {
  const headerConfig = useAppSelector(
    (state) => state.configs.general.data?.header
  );

  const { pathname } = useLocation();
  const segments = pathname.split("/").filter(Boolean);
  // Keep the current path (so SEO-slug pathname overrides stay applied) when the
  // landing page is rendered; otherwise anchor sections to the homepage.
  const isLandingRoute =
    segments.length === 0 ||
    (segments.length === 1 &&
      !NON_LANDING_ROUTES.has(segments[0]) &&
      segments[0] !== getFormLink());
  const basePath = isLandingRoute ? pathname : "/";

  function handleClick(activeLink: string, link: string) {
    openMenuBurger(false);
  }

  function bgHandleClick(e: any) {
    if (e.target.classList.contains("nav")) openMenuBurger(false);
  }

  const variant = process.env.REACT_APP_VARIANT ?? Variants.v0;

  if (variant === "v1") {
    return (
      <nav
        className={classNames("nav", isOpen ? "nav_active" : "")}
        onClick={(e) => bgHandleClick(e)}
      >
        <ul className="nav__list">
          {(headerConfig?.links ?? []).map((item, index) => (
            <React.Fragment key={item.link}>
              <li>
                <a
                  href={`${basePath}#${item.link}`}
                  className={classNames(
                    "nav__link",
                    activeLink === item.link ? "active" : ""
                  )}
                  onClick={() => handleClick(activeLink, item.link)}
                >
                  {item.name}
                </a>
              </li>
            </React.Fragment>
          ))}
        </ul>
      </nav>
    );
  }
  if (variant === "v2") {
    return (
      <nav
        className={classNames("nav", isOpen ? "nav_active" : "")}
        onClick={(e) => bgHandleClick(e)}
      >
        <ul className="nav__list">
          {(headerConfig?.links ?? []).map((item, index) => (
            <React.Fragment key={item.link}>
              <li>
                <a
                  href={`${basePath}#${item.link}`}
                  className={classNames(
                    "nav__link",
                    activeLink === item.link ? "active" : ""
                  )}
                  onClick={() => handleClick(activeLink, item.link)}
                >
                  {item.name}
                </a>
              </li>
              {index !== headerConfig!.links.length - 1 ? (
                <img src={headerDot} alt="header-dot" />
              ) : null}
            </React.Fragment>
          ))}
        </ul>
      </nav>
    );
  }
  if (variant === "v3") {
    return (
      <nav
        className={classNames("nav", isOpen ? "nav_active" : "")}
        onClick={(e) => bgHandleClick(e)}
      >
        <ul className="nav__list">
          {(headerConfig?.links ?? []).map((item, index) => (
            <React.Fragment key={item.link}>
              <li>
                <a
                  href={`${basePath}#${item.link}`}
                  className={classNames(
                    "nav__link",
                    activeLink === item.link ? "active" : ""
                  )}
                  onClick={() => handleClick(activeLink, item.link)}
                >
                  {item.name}
                </a>
              </li>
            </React.Fragment>
          ))}
        </ul>
      </nav>
    );
  }

  return (
    <nav
      className={classNames("nav", isOpen ? "nav_active" : "")}
      onClick={(e) => bgHandleClick(e)}
    >
      <ul className="nav__list">
        {(headerConfig?.links ?? []).map((item) => (
          <li
            className={classNames(
              "nav__item",
              activeLink === item.link ? "active" : ""
            )}
            key={item.link}
          >
            <a
              href={`${basePath}#${item.link}`}
              className={classNames(
                "nav__link",
                activeLink === item.link ? "active" : ""
              )}
              onClick={() => handleClick(activeLink, item.link)}
            >
              {item.name}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
